
<template>
    <div class="page">
        <div class="head-title">
            <div class="left">
                <ul class="breadcrumb">
                    <li>
                        <router-link to="/purchases/home" class="active">{{
                            $t("purchases")
                            }}</router-link>
                    </li>
                    <li>-</li>
                    <li>
                        <router-link to="/purchases/AllBills" class="active">{{
                            $t("bills")
                            }}</router-link>
                    </li>
                    <li>-</li>
                    <li>
                        <a class="active" href="#">{{ $t("add") }} {{ $t("invoice") }} {{ $t("purchases") }}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="main">
            <div class="head">
                <div class="head1">
                    <h3>{{ $t("add") }} {{ $t("invoice") }} {{ $t("purchases") }}</h3>
                </div>
                <div class="head2">
                    <button class="buttonconfirm" type="submit" :disabled="disabled" @click="submit">
                        {{ $t("save") }}
                    </button>
                </div>
            </div>
            <div class="body">
                <div class="part1">
                    <div class="part11">
                        <div class="mb-2 row">
                            <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("number") }}
                            </label>
                            <div class="col-sm-7">BILL-{{ id }}</div>
                        </div>
                        <div class="mb-2 row">
                            <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("date") }}
                                <span class="error-feedback" v-if="v$.date.$error">{{
                                    "*"
                                    }}</span></label>
                            <div class="col-sm-7">
                                <input type="date" class="form-control form-control-sm" id="inputEmail3" v-model="date" />
                            </div>
                        </div>
                        <div class="mb-2 row">
                            <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("description") }}
                                <span class="error-feedback" v-if="v$.description.$error">{{
                                    "*"
                                    }}</span></label>
                            <div class="col-sm-7">
                                <input type="text" class="form-control form-control-sm" id="inputEmail3"
                                    v-model="description" />
                            </div>
                        </div>

                        <div class="mb-2 row">
                            <label for="inputEmail3" class="col-sm-3 col-form-label-sm">{{ $t("invnum") }}
                                <span class="error-feedback"> </span></label>
                            <div class="col-sm-7">
                                <input type="text" class="form-control form-control-sm" id="invnum"
                                    v-model="invnum" />
                            </div>
                        </div>


                        <div class="mb-2 row">
                            <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("supplier") }}
                            </label>
                            <div class="col-sm-7">
                                <v-select :options="customers" label="name" v-model="sdata">
                                    <template #option="option">
                                        <span>{{ option.name }}</span>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <div class="mb-2 row">
                            <label for="inputEmail3" class="col-sm-2 col-form-label-sm">
                                {{ $t("Account") }}
                                <span class="error-feedback" v-if="v$.account.$error">{{
                                    "*"
                                    }}</span>
                            </label>
                            <div class="col-sm-7">
                                <v-select :options="accounts" label="namear" v-model="account">
                                    <template #option="option">
                                        <div class="option">
                                            <span>{{ option.namear }} - {{ option.actnum }}</span>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <div class="mb-2 row">
                            <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("date") }} {{ $t("due") }}
                                <span class="error-feedback" v-if="v$.duedate.$error">{{
                                    "*"
                                    }}</span></label>
                            <div class="col-sm-7">
                                <input type="date" class="form-control form-control-sm" id="inputEmail3"
                                    v-model="duedate" />
                            </div>
                        </div>
                        <div class="mb-2 row">
                            <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("date") }} {{ $t("supply") }}
                                <span class="error-feedback" v-if="v$.supplydate.$error">{{
                                    "*"
                                    }}</span></label>
                            <div class="col-sm-7">
                                <input type="date" class="form-control form-control-sm" id="inputEmail3"
                                    v-model="supplydate" />
                            </div>
                        </div>
                    </div>
                    <div class="part11">
                        <h4>{{ $t("data") }} {{ $t("customer") }}</h4>
                        <div class="mb-2 row">
                            <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                                {{ $t("name") }}
                            </label>
                            <div class="col-sm-7">
                                {{ customerdata.name }}
                            </div>
                        </div>
                        <div class="mb-2 row">
                            <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                                {{ $t("mobile") }}
                            </label>
                            <div class="col-sm-7">
                                {{ customerdata.mobile }}
                            </div>
                        </div>
                        <div class="mb-2 row">
                            <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                                {{ $t("email") }}
                            </label>
                            <div class="col-sm-7">
                                {{ customerdata.email }}
                            </div>
                        </div>
                        <div class="mb-2 row">
                            <label for="inputEmail3" class="col-sm-3 col-form-label-sm">
                                {{ $t("tax") }}
                            </label>
                            <div class="col-sm-7">
                                {{ customerdata.taxnumber }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ccenter">
                    <button @click="ccenter = !ccenter">
                        {{ $t("add") }} {{ $t("ccenter") }}
                    </button>
                    <div v-if="ccenter == true">
                        <span>{{ $t("ccenter") }}</span>
                        <select v-model="parent">
                            <option v-for="x in level1" :key="x" :value="x">
                                {{ x.namear }}
                            </option>
                        </select>
                        <select v-model="parent2" v-if="level2.length > 0">
                            <option v-for="x in level2" :key="x" :value="x">
                                {{ x.namear }}
                            </option>
                        </select>
                    </div>
                </div>
                <hr />
                <div class="mb-2 row">
                    <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("product") }}
                    </label>
                    <div class="col-sm-3">
                        <v-select :options="products" label="namear" v-model="product">
                            <template #option="option">
                                <span>{{ option.barcode }} - {{ option.namear }}</span>
                            </template>
                        </v-select>
                    </div>
                </div>
                <div class="part2">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th style="width: 12%">{{ $t("product") }}</th>
                                <th>{{ $t("description") }}</th>
                                <th style="width: 10%">{{ $t("quantity") }}</th>
                                <th style="width: 10%">{{ $t("unit type") }}</th>
                                <th>{{ $t("price") }}</th>
                                <th>{{ $t("discount") }}</th>
                                <th>{{ $t("total") }} {{ $t("befor") }} {{ $t("tax") }}</th>
                                <th>{{ $t("tax") }}</th>
                                <th>{{ $t("amount") }} {{ $t("tax") }}</th>
                                <th>{{ $t("total") }}</th>
                                <th>{{ $t("cancel") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(value, id) in data" :key="value">
                                <td>{{ id + 1 }}</td>
                                <td style="width: 20%">
                                    <span>{{ value.barcode }} - {{ value.pronamear }}</span>
                                </td>
                                <td>
                                    <input class="form-control form-control-sm" type="text" v-model="value.description" />
                                </td>
                                <td>
                                    <input class="form-control form-control-sm" type="number" min="1"
                                        v-model="value.quantity" @change="
                                value.tbt = Number(
                                  value.buyp * value.quantity -
                                    (value.buyp * value.quantity * value.discount) / 100
                                ).toFixed(2);
                                value.taxamount = Number(
                                  (value.tbt * value.tax) / 100
                                ).toFixed(2);
                                value.total = Number(
                                  Number(value.tbt) + (value.tbt * value.tax) / 100
                                ).toFixed(2);
                                calc();
                              " />
                                </td>
                                <td>{{ value.unittype }}</td>
                                <td>
                                    <input class="form-control form-control-sm" type="number" min="0" v-model="value.buyp"
                                        @change="
                                value.tbt = Number(
                                  value.buyp * value.quantity -
                                    (value.buyp * value.quantity * value.discount) / 100
                                ).toFixed(2);
                                value.taxamount = Number(
                                  (value.tbt * value.tax) / 100
                                ).toFixed(2);
                                value.total = Number(
                                  Number(value.tbt) + (value.tbt * value.tax) / 100
                                ).toFixed(2);
                                calc();
                              " />
                                </td>
                                <td>{{ value.discount }} %</td>
                                <td>{{ value.tbt }}</td>
                                <td style="display: flex">
                                    <input type="number" min="0" v-model="value.tax" style="width: 100px" @change="
                                value.tbt =
                                  value.buyp * value.quantity -
                                  (value.buyp * value.quantity * value.discount) / 100;
                                value.taxamount = (value.tbt * value.tax) / 100;
                                value.total = value.tbt + (value.tbt * value.tax) / 100;
                                calc();
                              " />
                                    %
                                </td>
                                <td>{{ value.taxamount }}</td>
                                <td>{{ value.total }}</td>
                                <td>
                                    <a href="#" @click.prevent="del(id)"><i class="bi bi-x-circle-fill"></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <hr />
                <div class="total">
                    <h4>{{ $t("total") }}</h4>
                    <div class="total1">
                        المبلغ قبل الضريبة <input type="text" disabled v-model="tbt" />
                    </div>
                    <div class="total1">
                        قيمة الضريبة <input type="text" disabled v-model="taxamount" />
                    </div>
                    <div class="total1">
                        بعد الضريبة <input type="text" disabled v-model="total" />
                    </div>
                </div>
                <div class="mb-2 row">
                    <label for="inputEmail3" class="col-sm-1 col-form-label-sm">{{ $t("notes") }}
                    </label>
                    <div class="col-sm-5">
                        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="notes"></textarea>
                    </div>
                </div>
                <!-- Payment Fields -->
                <div class="mb-2 row">
                    <label for="hasPayment" class="col-sm-2 col-form-label-sm">
                        {{ $t("has_payment") }}
                        <span class="error-feedback" v-if="v$.hasPayment.$error">*</span>
                    </label>
                    <div class="col-sm-7">
                        <select class="form-control form-control-sm" id="hasPayment" v-model="hasPayment">
                            <option value="no">{{ $t("no") }}</option>
                            <option value="yes">{{ $t("yes") }}</option>
                        </select>
                    </div>
                </div>
                <div v-if="hasPayment === 'yes'" class="payment-details">
                    <div class="mb-2 row">
                        <label for="paymentAmount" class="col-sm-2 col-form-label-sm">
                            {{ $t("amount") }}
                            <span class="error-feedback" v-if="v$.paymentAmount.$error">*</span>
                        </label>
                        <div class="col-sm-7">
                            <input type="number" class="form-control form-control-sm" id="paymentAmount"
                                v-model.number="paymentAmount" min="0" step="0.01" />
                        </div>
                    </div>
                    <div class="mb-2 row">
                        <label for="paymentType" class="col-sm-2 col-form-label-sm">
                            {{ $t("type") }}
                            <span class="error-feedback" v-if="v$.paymentType.$error">*</span>
                        </label>
                        <div class="col-sm-7">
                            <select class="form-control form-control-sm" id="paymentType" v-model="paymentType">
                                <option value="paid">{{ $t("paid") }}</option>
                                <option value="received">{{ $t("received") }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="mb-2 row">
                        <label for="paymentAccount" class="col-sm-2 col-form-label-sm">
                            {{ $t("Account") }}
                            <span class="error-feedback" v-if="v$.paymentAccount.$error">*</span>
                        </label>
                        <div class="col-sm-7">
                            <v-select :options="accountpayment" label="namear" v-model="paymentAccount"
                                @update:modelValue="updatePaymentAccount">
                                <template #option="option">
                                    <span>{{ option.namear }} - {{ option.actnum }}</span>
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <div class="mb-2 row">
                        <label for="paymentDescription" class="col-sm-2 col-form-label-sm">
                            {{ $t("description") }}
                            <span class="error-feedback" v-if="v$.paymentDescription.$error">*</span>
                        </label>
                        <div class="col-sm-7">
                            <textarea class="form-control form-control-sm" id="paymentDescription"
                                v-model="paymentDescription" rows="3"></textarea>
                        </div>
                    </div>
                    <div class="mb-2 row">
                        <label for="paymentDate" class="col-sm-2 col-form-label-sm">
                            {{ $t("date") }}
                            <span class="error-feedback" v-if="v$.paymentDate.$error">*</span>
                        </label>
                        <div class="col-sm-7">
                            <input type="date" class="form-control form-control-sm" id="paymentDate"
                                v-model="paymentDate" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

  <script>
import store from "@/store";
import useValidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import axios from "axios";
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import vSelect from "vue-select";
import moment from "moment";

export default {
  title: "Create Bill",
  components: {
    vSelect,
  },
  props: ["css"],
  async mounted() {
    try {
      const result3 = await axios.get("/data/allsupplier");
      if (result3.status === 200) {
        this.customers = result3.data.data;
      }
      const result2 = await axios.get("/data/allproducts");
      if (result2.status === 200) {
        this.products = result2.data.data;
      }
      const result4 = await axios.get("/data/allprojects");
      const result5 = await axios.get("/data/alltasks");
      const result6 = await axios.get("/data/billID");
      const result7 = await axios.get("/data/getcostcenter");
      if (result4.status === 200) {
        this.branches = result7.data.data;
        this.level1 = this.branches.filter((x) => x.level == 1);
        this.allprojects = result4.data.data;
        this.alltasks = result5.data.data;
        this.id = Number(result6.data.data[0].count) + 1;
      }
      const accountesResult = await axios.get("/data/getaccounttrue");
      if (accountesResult.status === 200) {
        this.accounts = accountesResult.data.data;
      }
      const accountPaymentResult = await axios.get("/data/accountpayment");
      if (accountPaymentResult.status === 200) {
        this.accountpayment = accountPaymentResult.data.data;
        console.log("Account payment options:", this.accountpayment); // Debug
      }
    } catch (error) {
      console.error("Error in mounted:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load data. Please try again.",
      });
    }
  },
  data() {
    return {
      disabled: false,
      v$: useValidate(),
      id: "",
      data: [],
      number: "",
      date: moment().format("YYYY-MM-DD"),
      description: "",
      invnum: "",
      customers: [],
      products: [],
      product: null,
      selection: false,
      customerid: "",
      customername: "",
      customerdata: {},
      taxamount: 0,
      tbt: 0,
      total: 0,
      addto: "",
      allprojects: [],
      alltasks: [],
      accounts: [],
      account: null,
      accountpayment: [],
      taskno: "",
      projectno: "",
      branchno: "",
      duedate: moment().format("YYYY-MM-DD"),
      supplydate: moment().format("YYYY-MM-DD"),
      sdata: null,
      parent: "",
      parent2: "",
      level1: [],
      level2: [],
      branches: [],
      ccenter: false,
      costn: "",
      costname: "",
      comm: "",
      commamount: 0,
      hasPayment: "no",
      paymentAmount: "",
      paymentType: "paid",
      paymentAccount: null,
      paymentAccountNo: "",
      paymentAccountNameAr: "",
      paymentAccountNameEn: "",
      paymentDescription: "",
      paymentDate: moment().format("YYYY-MM-DD"),
    };
  },
  validations() {
    return {
      date: { required },
      description: { required },
      account: { required },
      duedate: { required },
      supplydate: { required },
      hasPayment: { required },
      paymentAmount: {
        required: helpers.withMessage(
          "Payment amount is required and must be positive",
          (value) => (this.hasPayment === "yes" ? !!value && value > 0 : true)
        ),
      },
      paymentType: {
        required: helpers.withMessage(
          "Payment type is required",
          (value) => (this.hasPayment === "yes" ? !!value : true)
        ),
      },
      paymentAccount: {
        required: helpers.withMessage(
          "Payment account is required",
          (value) =>
            this.hasPayment === "yes"
              ? !!value && !!value.actnum && !!value.namear && !!value.nameen
              : true
        ),
      },
      paymentDescription: {
        required: helpers.withMessage(
          "Payment description is required",
          (value) => (this.hasPayment === "yes" ? !!value : true)
        ),
      },
      paymentDate: {
        required: helpers.withMessage(
          "Payment date is required",
          (value) => (this.hasPayment === "yes" ? !!value : true)
        ),
      },
    };
  },
  methods: {
    calc() {
      this.tbt = this.data.reduce((acc, array) => acc + Number(array.tbt), 0);
      this.taxamount = this.data.reduce(
        (acc, array) => acc + Number(array.taxamount),
        0
      );
      this.total = this.data.reduce(
        (acc, array) => acc + Number(array.total),
        0
      );
    },
    async del(id) {
      this.data.splice(id, 1);
      this.calc();
    },
    task() {
      const project = this.alltasks.find((x) => x.id == this.taskno)?.projectid;
      this.projectno = project || "";
    },
    updatePaymentAccount(value) {
      console.log("updatePaymentAccount triggered:", value); // Debug
      if (value && value.actnum && value.namear && value.nameen) {
        this.paymentAccountNo = value.actnum;
        this.paymentAccountNameAr = value.namear;
        this.paymentAccountNameEn = value.nameen;
      } else {
        this.paymentAccountNo = "";
        this.paymentAccountNameAr = "";
        this.paymentAccountNameEn = "";
        this.paymentAccount = null;
      }
    },
 async submit() {
  this.v$.$validate();
  if (!this.v$.$error) {
    this.disabled = true;
    try {
      if (
        this.hasPayment === "yes" &&
        (!this.paymentAccountNo ||
          !this.paymentAccountNameAr ||
          !this.paymentAccountNameEn)
      ) {
        throw new Error("Payment account details are incomplete");
      }

      const payload = {
        username: store.state.randp.username,
        due: this.date,
        description: this.description,
        invnum: this.invnum,
        duedate: this.duedate,
        supplydate: this.supplydate,
        cid: this.customerdata.sid || "",
        cname: this.customerdata.name || "",
        cmobile: this.customerdata.mobile || "",
        cmail: this.customerdata.email || "",
        ctax: this.customerdata.taxnumber || "",
        details: JSON.stringify(this.data),
        tbt: Number(this.tbt),
        tax: Number(this.taxamount),
        tat: Number(this.total),
        branch: this.branchno,
        project: this.projectno,
        task: this.taskno,
        notes: this.notes,
        costn: this.costn,
        costname: this.costname,
        account: this.account,
        hasPayment: this.hasPayment,
        paymentData:
          this.hasPayment === "yes"
            ? {
              amount: Number(this.paymentAmount),
              type: this.paymentType,
              actnum: this.paymentAccountNo,
              namear: this.paymentAccountNameAr,
              nameen: this.paymentAccountNameEn,
              description: this.paymentDescription,
              due: this.paymentDate,
            }
            : null,
        user: store.state.randp,
      };

      const result = await axios.post("/data/CreateBill", payload);
      if (result.status === 200) {
        this.redirectTo({ val: "AllBills" });
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "success",
          title: "Data Entry successfully",
        });
      } else {
        throw new Error(`Unexpected response status: ${result.status}`);
      }
    } catch (error) {
      console.error("Submission error:", error);
      let errorMessage = error.response?.data?.message || "Failed to create bill. Please try again.";
              console.log("Server error:", error.response.data.message);

      if (error.response && error.response.status === 500&& !errorMessage) {
        errorMessage = error.response.message ?? "خطأ في الخادم. يرجى الاتصال بالدعم أو المحاولة مرة أخرى لاحقًا.";
      }
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
      });
    } finally {
      this.disabled = false;
    }
  } else {
    Swal.fire({
      icon: "warning",
      title: "Validation Error",
      text: "Please fill all required fields correctly.",
    });
  }
},
    ...mapActions(["redirectTo"]),
  },
  watch: {
    parent() {
      this.level2 = this.branches.filter(
        (x) =>
          x.actnum.startsWith(this.parent.actnum) &&
          x.actnum != this.parent.actnum
      );
      this.costname = this.parent.namear || "";
      this.costn = this.parent.actnum || "";
    },
    parent2() {
      this.costname = this.parent2.namear || "";
      this.costn = this.parent2.actnum || "";
    },
    ccenter() {
      if (!this.ccenter) {
        this.costname = "";
        this.costn = "";
      }
    },
    async sdata() {
      if (this.sdata && this.sdata.sid) {
        try {
          const result3 = await axios.get(`/data/delsupplier/${this.sdata.sid}`);
          if (result3.status === 200) {
            this.customerdata = result3.data.data[0] || {};
            this.customername = this.sdata.name || "";
            this.customerid = this.sdata.sid || "";
          }
        } catch (error) {
          console.error("Error fetching supplier:", error);
        }
      } else {
        this.customerdata = {};
        this.customername = "";
        this.customerid = "";
      }
    },
    hasPayment(newVal) {
      if (newVal === "no") {
        this.paymentAmount = "";
        this.paymentType = "paid";
        this.paymentAccount = null;
        this.paymentAccountNo = "";
        this.paymentAccountNameAr = "";
        this.paymentAccountNameEn = "";
        this.paymentDescription = "";
        this.paymentDate = moment().format("YYYY-MM-DD");
      }
    },
    product() {
      if (this.product && this.product.namear) {
        const data2 = this.data.filter((x) => x.pronamear === this.product.namear);
        if (data2.length === 0) {
          this.data.push({
            proid: this.product.pid,
            pronamear: this.product.namear,
            pronameen: this.product.nameen,
            salep: this.product.salep,
            salec: this.product.salec,
            snamear: this.product.snamear,
            snameen: this.product.snameen,
            buyp: this.product.buyp,
            buyc: this.product.buyc,
            bnamear: this.product.bnamear,
            bnameen: this.product.bnameen,
            discount: this.product.discount,
            unittype: this.product.unittype,
            tax: this.product.tax,
            sn: this.product.sn,
            stock: this.product.stock,
            barcode: this.product.barcode,
            quantity: 1,
            tbt:
              this.product.buyp * 1 -
              (this.product.buyp * 1 * this.product.discount) / 100,
            taxamount: Number(
              ((this.product.buyp * 1 -
                (this.product.buyp * 1 * this.product.discount) / 100) *
                this.product.tax) /
              100
            ).toFixed(2),
            total: Number(
              this.product.buyp * 1 -
              (this.product.buyp * 1 * this.product.discount) / 100 +
              ((this.product.buyp * 1 -
                (this.product.buyp * 1 * this.product.discount) / 100) *
                this.product.tax) /
              100
            ).toFixed(2),
          });
          this.calc();
        }
      }
    },
  },
};
  </script>

  <style lang="scss" scoped>
.page {
    padding: 0.5%;
}

.main {
    width: 98%;
    margin: 1%;
    padding: 1%;
    border-radius: 5px;
    border: ridge 0.5px;
}

.head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
}

.head1 {
    width: 70%;
}

input {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
    text-align: center;
}

.head2 {
    width: 30%;
    text-align: center;
}

button {
    margin: 0.5%;
    padding: 2%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
}

.ccenter button {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
}

.head2 button a {
    color: white;
}

.table {
    margin-top: 1%;
}

table thead tr {
    border-radius: 5px;
    background-color: #eee;
}

select {
    width: 15%;
    margin: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
}

.part1 {
    display: flex;
    width: 100%;
}

.part11 {
    width: 50%;
    padding: 2%;
}

.payment-details {
    border: 1px solid #ccc;
    padding: 1%;
    margin-top: 1%;
    border-radius: 5px;
}

@media screen and (max-width: 576px) {
    .table {
        width: 90%;
        margin-left: 5%;
        margin-right: 5%;
        background-color: white;
        font-size: xx-small;
    }
}
</style>
